module.exports = __webpack_public_path__ + "media/32_Long.1b3e5056.mp3";